import { render, staticRenderFns } from "./DocWrite.vue?vue&type=template&id=494636e7&scoped=true"
import script from "./DocWrite.vue?vue&type=script&lang=js"
export * from "./DocWrite.vue?vue&type=script&lang=js"
import style0 from "./DocWrite.vue?vue&type=style&index=0&id=494636e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494636e7",
  null
  
)

export default component.exports